import { Box, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react';
import CategorySectionCreator from './CategorySectionCreator';
import { strings } from 'localisation';
import { GlobalContext } from 'context/GlobalState';
import { Link } from 'react-router-dom';
import { routerUrls } from 'constants';
import PropTypes from 'prop-types';

// GOTOBED CATEGORIES COMPONENT ON MAIN PAGE
// `showHeader={false}` renders only the tile grid (no title/subtitle), so a host
// page - e.g. Home - can supply its own section heading.
export const getCategoryTiles = (lang) => [
  {
    audience: 'adult',
    cat: 1,
    subCat: 2,
    categorySlug: 'spalno-belio',
    subCategorySlug: 'kalufki',
    name: strings[lang].categoryPillowcases,
    title: strings[lang].see + ' ' + strings[lang].categoryPillowcases,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/kat/bed.jpg',
    size: 'small'
  },
  {
    audience: 'adult',
    cat: 1,
    subCat: 3,
    categorySlug: 'spalno-belio',
    subCategorySlug: 'charshafi-s-lastik',
    name: strings[lang].categoryFittedSheets,
    title: strings[lang].see + ' ' + strings[lang].categoryFittedSheets,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/kat/bed2.jpg',
    size: 'medium'
  },
  {
    audience: 'adult',
    cat: 1,
    subCat: 6,
    categorySlug: 'spalno-belio',
    subCategorySlug: 'krugli-sharshafi-s-lastik',
    name: strings[lang].categoryRoundFittedSheets,
    title: strings[lang].see + ' ' + strings[lang].categoryRoundFittedSheets,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/kat/round.jpg',
    size: 'small'
  },
  {
    audience: 'adult',
    cat: 1,
    subCat: 4,
    categorySlug: 'spalno-belio',
    subCategorySlug: 'plikove-za-zavivka',
    name: strings[lang].categoryDuvetCovers,
    title: strings[lang].see + ' ' + strings[lang].categoryDuvetCovers,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/kat/bed3.jpg',
    size: 'large'
  },
  {
    audience: 'adult',
    cat: 1,
    subCat: 1,
    categorySlug: 'spalno-belio',
    subCategorySlug: 'charshafi',
    name: strings[lang].categoryBedSheets,
    title: strings[lang].see + ' ' + strings[lang].categoryBedSheets,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/kat/bed4.jpg',
    size: 'medium'
  },
  {
    audience: 'kids',
    cat: 2,
    subCat: 8,
    categorySlug: 'za-bebeto-i-deteto',
    subCategorySlug: 'kalufki-kids',
    name: strings[lang].categoryKidsPillowcases,
    title: strings[lang].see + ' ' + strings[lang].categoryKidsPillowcases,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/admin/R-189-6.jpg',
    size: 'small'
  },
  {
    audience: 'kids',
    cat: 2,
    subCat: 10,
    categorySlug: 'za-bebeto-i-deteto',
    subCategorySlug: 'plikove-za-zavivka-kids',
    name: strings[lang].categoryKidsDuvetCovers,
    title: strings[lang].see + ' ' + strings[lang].categoryKidsDuvetCovers,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/admin/R-174-5.jpg',
    size: 'large'
  },
  {
    audience: 'kids',
    cat: 2,
    subCat: 7,
    categorySlug: 'za-bebeto-i-deteto',
    subCategorySlug: 'charshafi-kids',
    name: strings[lang].categoryKidsBedSheets,
    title: strings[lang].see + ' ' + strings[lang].categoryKidsBedSheets,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/admin/R-148-6.jpg',
    size: 'medium'
  },
  {
    audience: 'kids',
    cat: 2,
    subCat: 9,
    categorySlug: 'za-bebeto-i-deteto',
    subCategorySlug: 'charshafi-s-lastik-kids',
    name: strings[lang].categoryKidsFittedSheets,
    title: strings[lang].see + ' ' + strings[lang].categoryKidsFittedSheets,
    imgUrl: 'https://gotobed.eu/wp-content/uploads/files/admin/R-179-4.jpg',
    size: 'small'
  }
];

export default function PopularProducts({ showHeader = true, audience, materialId, materialLabel }) {
  const { lang } = useContext(GlobalContext);
  const productsData = getCategoryTiles(lang).filter(
    (item) => !audience || item.audience === audience
  );

  const getGridSize = () => {
    return { xs: 12, md: 4 };
  };

  const grid = (
    <Grid container spacing={3}>
      {productsData?.map((item) => (
        <Grid item {...getGridSize()} key={item.subCat}>
          <Link
            style={{
              color: 'inherit',
              textDecoration: 'none',
              display: 'block',
              height: '100%'
            }}
            to={
              routerUrls.products +
              '/' +
              item.categorySlug +
              '/' +
              item.subCategorySlug +
              '/' +
              item.cat +
              '/' +
              item.subCat +
              (materialId ? '/' + materialId : '')
            }>
            <Box
              sx={{
                position: 'relative',
                height: { xs: 200, md: 300 },
                borderRadius: '12px',
                overflow: 'hidden',
                transition: 'all 0.3s ease-in-out',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }
              }}>
              <Box
                component="img"
                src={item.imgUrl}
                alt={materialLabel ? `${item.name} – ${materialLabel}` : item.title}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              {/* The photo is left untinted, so this gradient is the only thing keeping the white
                  label legible - it has to stay dark enough to carry the text on its own. */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: 2,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0))'
                }}>
                <Typography
                  variant="h6"
                  sx={{
                    // h1–h6 are Playfair (serif) in the theme. This tile label reads as
                    // UI, not as editorial display type, so it takes the body sans.
                    fontFamily: (t) => t.typography.body1.fontFamily,
                    fontWeight: 600,
                    color: 'white',
                    textAlign: 'center',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                  }}>
                  {materialLabel ? `${item.name} – ${materialLabel}` : item.title}
                </Typography>
              </Box>
            </Box>
          </Link>
        </Grid>
      ))}
    </Grid>
  );

  if (!showHeader) return grid;

  return (
    <CategorySectionCreator
      title={strings[lang].categoriesTitle}
      subtitle={strings[lang].categoriesSubTitle}
      seeMoreLink="">
      {grid}
    </CategorySectionCreator>
  );
}

PopularProducts.propTypes = {
  showHeader: PropTypes.bool,
  audience: PropTypes.oneOf(['adult', 'kids']),
  materialId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  materialLabel: PropTypes.string
};
